import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Button } from '@Components/Button';

interface IconLocalImportModalProps {
  importFunction: (file: ArrayBuffer) => Promise<void>;
  onClose: () => void;
}

export const IconLocalImportModal = ({ importFunction, onClose }: IconLocalImportModalProps) => {
  const [file, setFile] = useState<File | undefined>();
  const [importing, setImporting] = useState(false);

  const importPlan = () => {
    if (!file) {
      return;
    }
    setImporting(true);
    const reader = new FileReader();
    reader.onload = async e => {
      const binaryString = e?.target?.result;
      try {
        if (binaryString instanceof ArrayBuffer) {
          await importFunction(binaryString);
        }
      } finally {
        setImporting(false);
        onClose();
      }
    };
    reader.readAsArrayBuffer(file);
  };

  return (
    <Modal show onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Import ICON Local Plan</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          Import an ICON Local plan from an XLSX schedule summary. Rows will be transformed using
          the{' '}
          <a href='/linear/icon-local-mappings' target='_blank' rel='noopener noreferrer'>
            ICON Local Linear mappings
          </a>{' '}
          and added as pending changes.
        </div>
        <input
          type='file'
          accept='.xlsx,.xls'
          onChange={e => {
            const uploadedFile = e.target.files;
            setFile(uploadedFile?.[0]);
          }}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={!file} loading={importing} onClick={importPlan}>
          Import
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
